// extracted by mini-css-extract-plugin
module.exports = {"mediaButtonIcon":"_1raPf","unmuted":"_3hXlj","muted":"_2X7MV","volumeBtn":"_1nwJR","volumeScale":"_2mWb7","on":"_3cHdS","colorBlock":"_1kYvW","off":"ZefOh","colorBlank":"_3_haC"};